import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { login } from 'action/auth'
import React from 'react'
import PropTypes from 'prop-types'
import { Button, Form as BSForm } from 'react-bootstrap'
import { Form, Field } from 'react-final-form'
import styles from './styles'

const LoginForm = ({ login, toggle, generalDidError }) => (
  <Form
    onSubmit={login}
    render={({ handleSubmit, submitting, pristine }) => (
      <BSForm
        className='contact-form'
        onSubmit={handleSubmit}
      >
        {addFields()}
        {generalDidError && <p className={styles.error_message}>Invalid Email or Password, please try again.</p>}
        <Button
          className={styles.submit_button}
          disabled={submitting}
          type='submit'
        >
          {submitting ? 'Loading...' : 'Login'}
        </Button>
      </BSForm>
    )}
    subscription={{ pristine: true, submitting: true }}
  />
)

const addFields = () => (
  <>
    <Field
      className={styles.fields}
      component='input'
      name='email'
      placeholder='Email'
      type='email'
    />
    <Field
      className={styles.fields}
      component='input'
      name='password'
      placeholder='Password'
      type='password'
    />
  </>
)

LoginForm.propTypes = {
  generalDidError: PropTypes.bool,
  login: PropTypes.func.isRequired,
  toggle: PropTypes.func
}

const mapStateToProps = (state) => ({
  generalDidError: state.auth.generalDidError
})

export default connect(
  mapStateToProps,
  (dispatch) => ({
    login: bindActionCreators(login, dispatch)
  })
)(LoginForm)
